import { useLocation } from "react-router-dom";

import { useLoanApplicationNavbar } from "../../context/LoanApplicationNavbarContext";
import { useIsMobile } from "../../../../unified-dashboard/src/shared/hooks/useIsMobile";
import MainNavbar from "../../../../unified-dashboard/src/components/layout/navbar/MainNavbar";
import { LoanApplicationMobileNavbar } from "../../../../unified-dashboard/src/components/layout/navbar/LoanApplicationMobileNavbar";

export default function Navbar() {
  const location = useLocation();
  const { loanData } = useLoanApplicationNavbar();
  const isMobileScreen = useIsMobile(640);

  const isLoanApplicationDetailsPage = location.pathname.match(
    /^\/loan-applications\/details\/([^/]+)\/([^/]+)/
  );

  if (isLoanApplicationDetailsPage && loanData && isMobileScreen) {
    return <LoanApplicationMobileNavbar loanData={loanData} />;
  }

  return <MainNavbar />;
}
